export const ANIMATION_FRAME = 'ANIMATION_FRAME'
export const INCREMENT_SCORE = 'INCREMENT_SCORE'
export const DECREMENT_LIVES = 'DECREMENT_LIVES'
